module.exports = __webpack_public_path__ + "img/KSC01303.ae04193a.jpg";